import { useMutation } from "react-query";
import {
  fetchProductDetail,
  fetchProductsCreators,
  fetchProductSKU,
  fetchProductsLives,
  fetchProductsTrends,
  fetchProductsVideos,
  fetchShopDetail,
  fetchProductContainsShowcase,
  fetchProductsCheckShowcase,
  fetchProductsAddShowcase,
  fetchShowcaseAuthUrl,
  fetchShowcaseAuthUser,
  fetchSamplesCheck,
  fetchApplySamples,
  fetchSamplesAuthorizedCreate,
  fetchSamplesAuthorizedCheck,
  fetchProductsHighPassRecommend,
} from ".";

export const useSamplesAuthorizedCheck = () =>
  useMutation(fetchSamplesAuthorizedCheck);
export const useSamplesAuthorizedCreate = () =>
  useMutation(fetchSamplesAuthorizedCreate);
export const useApplySamples = () => useMutation(fetchApplySamples);
export const useSamplesCheck = () => useMutation(fetchSamplesCheck);
export const useShowcaseAuthUser = () => useMutation(fetchShowcaseAuthUser);
export const useShowcaseAuthUrl = () => useMutation(fetchShowcaseAuthUrl);
export const useProductsAddShowcase = () =>
  useMutation(fetchProductsAddShowcase);
export const useProductsCheckShowcase = () =>
  useMutation(fetchProductsCheckShowcase);
export const useProductContainsShowcase = () =>
  useMutation(fetchProductContainsShowcase);
export const useProductDetail = () => useMutation(fetchProductDetail);
export const useProductSKU = () => useMutation(fetchProductSKU);
export const useProductTrend = () => useMutation(fetchProductsTrends);
export const useProductVideos = () => useMutation(fetchProductsVideos);
export const useProductLive = () => useMutation(fetchProductsLives);
export const useProductCreators = () => useMutation(fetchProductsCreators);
export const useShopDetail = () => useMutation(fetchShopDetail);
export const useProductsHighPassRecommend = () =>
  useMutation(fetchProductsHighPassRecommend);
